import { combineReducers } from '@reduxjs/toolkit'
import loginSlice from '../features/userauth/login/LogIn/log-in-slice'
import inventorySlice from '../features/inventory/Inventory/inventory-slice'
import itemTagSlice from '../features/inventory/ItemDetails/item-tag-slice'
import itemCodeSlice from '../features/inventory/ItemCodeSummary/item-code-slice'
import itemSpecialPricingSlice from '../features/inventory/ItemSpecialPricing/item-special-pricing-slice'
import serialNumbersSlice from '../features/SerialNumbers/serial-numbers-slice'
import orderAllocationsSummarySlice from '../features/inventory/OrderAllocations/order-allocations-summary-slice'
import orderAllocationsSlice from '../features/inventory/OrderAllocations/order-allocations-slice'
import invoiceSlice from '../features/invoice/Invoices/invoice-slice'
import creditInvoiceSlice from '../features/invoice/CreditInvoices/credit-invoice-slice'
import customerGroupSlice from '../features/inventory/CustomerGroup/customer-group-slice'
import orderSlice from '../features/outboundorders/Orders/order-slice'
import orderListSlice from '../features/outboundorders/OrderList/order-list-slice'
import orderDetailsSlice from '../features/outboundorders/OrderDetails/order-details-slice'
import snackbarSlice from '../components/GenericSnackbar/generic-snackbar-slice'
import userManagementSlice from '../features/UserManagement/user-management-slice'
import staticDataSlice from '../features/userauth/login/static-data-slice'
import inviteUserSlice from '../features/UserManagement/components/InviteUserModal/invite-user-modal-slice'
import updateUserRoleSlice from '../features/UserManagement/components/UserRoleUpdateModal/update-user-role-slice'
import viewRoleSlice from '../features/rolemgmt/RoleManagement/view-role-slice'
import permissionsListSlice from '../features/rolemgmt/RoleManagement/components/PermissionsList/permissions-list-slice'
import updateRoleSlice from '../features/rolemgmt/RoleManagement/components/UpdateRole/update-role-slice'
import updatePermissionSlice from '../features/rolemgmt/PermissionManagement/components/UpdatePermission/update-permission-slice'
import viewPermissionSlice from '../features/rolemgmt/PermissionManagement/view-permission-slice'
import orderDocumentTypesSlice from '../features/outboundorders/OrderDetails/order-document-slice'
import holdAllocationSlice from '../features/holdallocation/hold-allocation-slice'
import holdAllocationDetailSlice from '../features/holdallocation/hold-allocation-detail-slice'

const roleManagementReducers = combineReducers({
  viewRole: viewRoleSlice,
  updateRole: updateRoleSlice,
})
const permissionManagementReducers = combineReducers({
  viewPermission: viewPermissionSlice,
  updatePermission: updatePermissionSlice,
})

/* Add reducers here */
export const rootReducers = combineReducers({
  creditInvoice: creditInvoiceSlice,
  customerGroup: customerGroupSlice,
  inventory: inventorySlice,
  inviteUser: inviteUserSlice,
  updateUserRole: updateUserRoleSlice,
  invoice: invoiceSlice,
  itemTag: itemTagSlice,
  itemCode: itemCodeSlice,
  itemSpecialPricing: itemSpecialPricingSlice,
  login: loginSlice,
  order: orderSlice,
  orderList: orderListSlice,
  orderDetails: orderDetailsSlice,
  orderAllocationsSummary: orderAllocationsSummarySlice,
  orderAllocations: orderAllocationsSlice,
  serialNumbers: serialNumbersSlice,
  orderDocument: orderDocumentTypesSlice,
  snackbar: snackbarSlice,
  staticData: staticDataSlice,
  userManagement: userManagementSlice,
  roleManagement: roleManagementReducers,
  permissionManagement: permissionManagementReducers,
  permissions: permissionsListSlice,
  holdAllocation: holdAllocationSlice,
  holdAllocationDetail: holdAllocationDetailSlice,
})
